import axios from "axios";
import { Servidor } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

/**
 * El backend pasó a exigir autenticación en todos los endpoints de datos:
 * sin token responde 401 {"error":"No autenticado"}.
 *
 * Adjuntamos el token con un interceptor y verificamos tanto expiración JWT
 * como respuestas 401 para limpiar sesión y redirigir limpiamente a login.
 */

const CLAVE_TOKEN = "toke_almacenado" + NegocioConfig.sistema;
const CLAVE_USUARIO = "usuario_almacenado" + NegocioConfig.sistema;

/**
 * Verifica si un token JWT ha expirado por su claim 'exp'
 */
const esTokenExpirado = (tokenStr) => {
    try {
        if (!tokenStr || typeof tokenStr !== "string") return true;
        const partes = tokenStr.split(".");
        if (partes.length !== 3) return false;
        const payloadJson = atob(partes[1].replace(/-/g, "+").replace(/_/g, "/"));
        const payload = JSON.parse(payloadJson);
        if (payload && payload.exp && typeof payload.exp === "number") {
            // Margen de 10 segundos
            return Date.now() >= (payload.exp * 1000) - 10000;
        }
        return false;
    } catch (e) {
        return false;
    }
};

/** Lee el token de localStorage. useLocalStorage lo guarda serializado. */
export const leerToken = () => {
    try {
        const valor = window.localStorage.getItem(CLAVE_TOKEN);
        if (!valor) return null;
        const token = JSON.parse(valor);
        if (typeof token === "string" && token.length > 0) {
            if (esTokenExpirado(token)) {
                console.warn("Token JWT expirado detectado en localStorage. Limpiando sesión...");
                window.localStorage.removeItem(CLAVE_TOKEN);
                window.localStorage.removeItem(CLAVE_USUARIO);
                return null;
            }
            return token;
        }
        return null;
    } catch (e) {
        return null;
    }
};

let yaRedirigiendo = false;

/**
 * Adjunta el token si existe y captura respuestas 401 para redirigir a login
 */
const adjuntarTokenYControlar401 = (instancia) => {
    // 1. Interceptor de Petición
    instancia.interceptors.request.use((config) => {
        const yaTiene =
            config.headers?.Authorization || config.headers?.authorization;

        if (!yaTiene) {
            const token = leerToken();
            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    });

    // 2. Interceptor de Respuesta (401 - Sesión Vencida)
    instancia.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                const url = (error.config?.url || "").toLowerCase();
                const esLogin = url.includes("iniciosesion") || url.includes("login");

                if (!esLogin && !yaRedirigiendo) {
                    yaRedirigiendo = true;
                    console.warn("Sesión expirada o no autorizada (401). Limpiando sesión y redirigiendo a login...");
                    window.localStorage.removeItem(CLAVE_TOKEN);
                    window.localStorage.removeItem(CLAVE_USUARIO);

                    if (!window.location.pathname.includes("/login")) {
                        setTimeout(() => {
                            window.location.href = "/login?expirado=true";
                        }, 250);
                    }
                }
            }
            return Promise.reject(error);
        }
    );

    return instancia;
};

export const AxiosPublico = adjuntarTokenYControlar401(
    axios.create({
        baseURL: Servidor,
        timeout: 15000,
        headers: { "Content-Type": "application/json" },
    })
);

export const AxiosPrivado = adjuntarTokenYControlar401(
    axios.create({
        baseURL: Servidor,
        timeout: 15000,
        headers: { "Content-Type": "application/json" },
    })
);

export const AxiosImagen = adjuntarTokenYControlar401(
    axios.create({
        baseURL: Servidor,
        timeout: 15000,
        headers: { "Content-Type": "multipart/form-data" },
    })
);
